// extracted by mini-css-extract-plugin
export default {"load_screen":"load-screen_load_screen__+20ZE","wrapper":"load-screen_wrapper__Vd0lj","logo_img":"load-screen_logo_img__KvCjS","logo":"load-screen_logo__nE0E2"};